const ExpandMore = ({ size = 24, color = "currentColor", className = "" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
            className={className}
        >
            <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"/>
        </svg>
    )
}

export default ExpandMore;
